module.exports = __webpack_public_path__ + "img/laboratorio_9-16.b7cc2347.jpg";